/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Phone",
  size: 20
}

const SvgPhone = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      d="M15.5 17c0 .8-.7 1.5-1.5 1.5H7c-.8 0-1.5-.7-1.5-1.5V3c0-.8.7-1.5 1.5-1.5h7c.8 0 1.5.7 1.5 1.5v14h0z"
    />
    <circle cx={10.5} cy={16.5} r={0.8} />
  </Svg>
)

SvgPhone.defaultProps = defaultProps
export default SvgPhone
